import React from 'react';
import Icon from '../../../components/AppIcon';

const RevenueKPICard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  iconColor, 
  forecast,
  subtitle 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-warning';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="card hover:shadow-lg transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="caption text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-data">
            {value}
          </h3>
          {subtitle && (
            <p className="caption text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div 
          className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${iconColor}20` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Icon name={getChangeIcon()} size={16} className={getChangeColor()} />
          <span className={`text-sm font-semibold ${getChangeColor()}`}>
            {change}
          </span>
          <span className="caption text-muted-foreground">vs last period</span>
        </div>
        {forecast && (
          <div className="flex items-center gap-1">
            <Icon name="Target" size={14} className="text-muted-foreground" />
            <span className="caption text-muted-foreground">{forecast}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueKPICard;